<div class="modal-header">
    <button type="button" class="close" (click)="dismissModal()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <div class="container h-100">
        <app-optimization-preferences (settingsChange)="settingsChanged()"></app-optimization-preferences>
        <app-optimization-settings
            (heavyTaskCapacityLoad)="heavyTaskCapacityLoaded($event)"
            (settingsChange)="settingsChanged()"
        ></app-optimization-settings>
    </div>
    <app-spinner
        [overlay]="true"
        [overlayRounded]="true"
        [visible]="saving"
        infoText="LOADING_INFO_UPDATING_OPTIMIZATION_SETTINGS"
    ></app-spinner>
</div>

<div class="modal-footer">
    <div class="d-flex align-items-center">
        @if (revertResetVisible) {
            <app-tooltip
                appCustomPopover
                placement="top"
                popoverText="REVERT_RESET_SETTINGS_INFO"
                position="top"
                popoverDelay="2000"
                [compact]="true"
            >
                <ng-container icon>
          <span
              class="vismaicon vismaicon vismaicon-refresh vismaicon-reverse mr-2"
              (click)="revertReset()"
          ></span>
                </ng-container>
            </app-tooltip>
        }
        <button
            type="button"
            class="btn btn-default"
            [disabled]="revertResetVisible"
            (click)="resetDefault()"
            translate="BUTTON_FILTER_RESET"
        ></button>
    </div>

    <div class="d-flex flex-1 justify-content-end">
        <button type="button" id="secondary" class="btn btn-secondary mr-2" (click)="dismissModal()">
            {{ 'CANCEL' | translate }}
        </button>
        <button
            type="button"
            id="primary"
            class="btn btn-primary"
            [disabled]="saving || loadingHeavyTaskCapacity || !changed"
            (click)="save()"
        >
            {{ 'SAVE' | translate }}
        </button>
    </div>
</div>
